module.exports = __webpack_public_path__ + "static/logo-1a253d459cd6f42a087a9560e2996a9d.png";